// extracted by mini-css-extract-plugin
export default {"flexVertical":"_6KwdVpIWpfFOG-HKD1k3l","flexHorizontal":"_2e3SSV5C70k5JyF8g5bEWf","labelHeader":"_3M5Kr-j8uBnOnwSmc3IVsf","labelDesc":"_2KTwbH8FnFmKRbD0N3k5CM"};